import TagManager from "react-gtm-module";

/**
 * Initializes Google Tag Manager
 */
export const initializeAnalytics = () => {
    try {
        if (window.appConfig?.gtmId != null) {
            TagManager.initialize({
                gtmId: window.appConfig.gtmId,
            });
        }
    } catch (error) {
        console.error("Failed to initialize GTM:", error);
    }
};
